export default {
  base: {
    remove: 'Xóa bỏ',
    cancel: 'Hủy bỏ',
    confirm: 'Xác nhận',
    inert: 'Chèn vào',
    width: 'Độ rộng',
    height: 'Độ cao'
  },
  controls: {
    clear: 'Xóa toàn bộ nội dung',
    undo: 'Hủy bỏ',
    redo: 'Làm lại',
    fontSize: 'Size chữ',
    lineHeight: 'Độ cao hàng',
    letterSpacing: 'Khoảng cách chữ',
    textIndent: 'Khoảng cách đoạn văn',
    increaseIndent: 'Tăng khoảng cách',
    decreaseIndent: 'Giảm khoảng cách',
    border: 'Đường viền',
    color: 'Màu sắc',
    textColor: 'Màu chữ',
    backgroundColor: 'Màu nền',
    tempColors: 'Màu tạm thời',
    bold: 'Tô đậm',
    italic: 'In nghiêng',
    underline: 'Gạch dưới',
    strikeThrough: 'Xóa gạch dưới',
    fontFamily: 'Font chữ',
    textAlign: 'Căn chỉnh văn bản',
    alignLeft: 'Căn trái',
    alignCenter: 'Căn giữa',
    alignRight: 'Căn phải',
    alignJustify: 'Hai lề',
    floatLeft: 'Float left',
    floatRight: 'Float right',
    superScript: 'Chỉ số trên',
    subScript: 'Chỉ số dưới',
    removeStyles: 'Xóa style',
    headings: 'Tiêu đề',
    header: 'Tiêu đề',
    normal: 'Quy tắc thông thường',
    orderedList: 'Kiểu sắp xếp',
    unorderedList: 'Kiểu không sắp xếp',
    blockQuote: 'Trích dẫn',
    code: 'Code',
    link: 'Liên kết',
    unlink: 'Gỡ liên kết',
    hr: 'Horizontal line',
    media: 'Media',
    mediaLibirary: 'Kho media',
    emoji: 'Biểu tượng cảm xúc',
    fullscreen: 'Toàn màn hình',
    exitFullscreen: 'Thoát khỏi chế độ toàn màn hình',
  },
  linkEditor: {
    textInputPlaceHolder: 'Nhập văn bản liên kết',
    linkInputPlaceHolder: 'Nhập địa chỉ liên kết',
    inputWithEnterPlaceHolder: 'Nhập địa chỉ liên kết và Enter',
    openInNewWindow: 'Mở trong tab mới',
    removeLink: 'Gỡ liên kết'
  },
  audioPlayer: {
    title: 'Phát tệp âm thanh'
  },
  videoPlayer: {
    title: 'Phát tệp video',
    embedTitle: 'Media nhúng'
  },
  media: {
    image: 'Hình ảnh',
    video: 'Video',
    audio: 'Âm thanh',
    embed: 'Media nhúng'
  }
}